import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  style: {"padding":"8px 24px","margin-bottom":"20px"},
  "txt-center": ""
}
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = {
  dark: "",
  "f-w-600": ""
}
const _hoisted_4 = {
  key: 0,
  "txt-center": ""
}
const _hoisted_5 = {
  dark: "",
  "f-w-600": ""
}
const _hoisted_6 = {
  key: 1,
  "txt-center": ""
}
const _hoisted_7 = {
  dark: "",
  "f-w-600": ""
}
const _hoisted_8 = {
  dark: "",
  "f-w-600": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_space = _resolveComponent("el-space")!
  const _directive_blur = _resolveDirective("blur")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_ctx.talent)
          ? (_openBlock(), _createBlock(_component_el_avatar, {
              key: 0,
              size: 100
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.initials(_ctx.talent)), 1)
                ])), [
                  [_directive_blur, _ctx.talent]
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.talent.firstName) + " " + _toDisplayString(_ctx.talent.lastName), 1)
        ])), [
          [_directive_blur, _ctx.talent]
        ])
      ]),
      (_ctx.opportunity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { "mute-secondary": "" }, "On ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.opportunity.outcome), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.opportunity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", null, [
              _createVNode(_component_el_space, {
                wrap: "",
                size: 10
              }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { "mute-secondary": "" }, "Opportunity from ", -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$moment(_ctx.opportunity.startDate).format("D MMM yy")), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { "mute-secondary": "" }, " to ", -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$moment(_ctx.opportunity.endDate).format("D MMM yy")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}